import { render, staticRenderFns } from "./PostprocessingTemplateEditModal.vue?vue&type=template&id=4e6d2e72&scoped=true&"
import script from "./PostprocessingTemplateEditModal.vue?vue&type=script&lang=js&"
export * from "./PostprocessingTemplateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PostprocessingTemplateEditModal.vue?vue&type=style&index=0&id=4e6d2e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d2e72",
  null
  
)

export default component.exports